export default [
  {
    path: '/',
    redirect: { name: 'NewSessionWelcome' },
  },
  {
    path: '/new',
    redirect: { name: 'NewSessionWelcome' },
    children: [
      {
        path: 'test',
        component: () => import('@/pages/new/test'),
        meta: { title: 'New Test Page' },
      },
      {
        path: 'auth',
        component: () => import('@/layouts/new/auth'),
        children: [
          {
            path: 'login',
            name: 'NewLogin',
            component: () => import('@/pages/new/auth/login'),
            meta: { title: 'Login', authPage: true },
          },
          {
            path: 'logout',
            name: 'Logout',
            component: () => import('@/pages/new/auth/logout'),
            meta: { title: 'Logout' },
          },
        ],
      },
      {
        path: 'quiz',
        component: () => import('@/layouts/new/default'),
        children: [
          {
            path: 'welcome',
            name: 'NewSessionWelcome',
            component: () => import('@/pages/new/quiz/welcome'),
            meta: { title: 'Welcome', requiresAuth: true },
          },
          {
            path: '',
            name: 'NewSessionIndex',
            component: () => import('@/pages/new/quiz/index'),
            meta: { title: 'Quiz', requiresAuth: true },
          },
          {
            path: 'result',
            name: 'NewSessionResult',
            component: () => import('@/pages/new/quiz/result'),
            meta: { title: 'Quiz Result', requiresAuth: true },
          },
        ],
      },
    ],
  },
];
